let base;

const envName = process.env.APP_ENV || 'development';
const topLevelDomain = envName !== 'development' ? location.host.split('.').pop() : '';
const isNotProduction = envName !== 'production' && envName !== 'productionNew';

// API URL resolution: Use API_SUBDOMAIN for non-production if set, otherwise check
// built-in environment map. Custom QA environments MUST set API_SUBDOMAIN.
// See README.md "API URL Resolution Logic" section for details.
if (process.env.API_SUBDOMAIN && isNotProduction) {
  base = `https://${process.env.API_SUBDOMAIN}.recorrido.${topLevelDomain}`;
} else {
  const domainsByEnvironment = {
    productionNew: `https://kexa-production.recorrido.${topLevelDomain}`,
    production: `http://kexa.recorrido.${topLevelDomain}`,
    qa: `https://kexa-qa.recorrido.${topLevelDomain}`,
  };

  base = domainsByEnvironment[envName] || 'http://localhost:4000';
}

export default {
  API_URL: `${base}/api/v1`,
  TOKEN_URL: `${base}/token`,
};



// WEBPACK FOOTER //
// ./src/constants/Url.constants.js